<template>
<div>
  <el-table :data="tableData" border default-expand-all stripe :header-cell-style="{'text-align':'center'}" cell-style="{'text-align':'center'}" style="width: 100%;margin-bottom: 20px;" class="tb-edit" highlight-current-row @row-click="handleCurrentChange">
    <el-table-column prop="id" label="序号">
      <template slot-scope="scope">
        <span>{{scope.$index + 1}}</span>
      </template>
    </el-table-column>
    <el-table-column label="价格区间">
      <el-table-column prop="startPrice" label="起(不含)">
        <!--<template scope="scope">
          <el-input type="number" size="small" v-model="scope.row.startPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.startPrice}}</span>
        </template>-->
      </el-table-column>
      <el-table-column prop="endPrice" label="止(包含)">
        <!--<template scope="scope">
          <el-input type="number" size="small" v-model="scope.row.endPrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.endPrice}}</span>
        </template>-->
      </el-table-column>
    </el-table-column>

    <el-table-column label="立返">
      <el-table-column prop="backupServicePriceReference" label="服务费参考"></el-table-column>
      <el-table-column label="服务费">
        <template slot-scope="scope">
          <el-input type="number" size="small" v-model="scope.row.backupServicePrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.backupServicePrice}}</span>
        </template>
      </el-table-column>
    </el-table-column>

    <el-table-column label="货返">
      <el-table-column prop="goodReturnServicePriceReference" label="服务费参考"></el-table-column>
      <el-table-column label="服务费">
        <template slot-scope="scope">
          <el-input type="number" size="small" v-model="scope.row.goodReturnServicePrice" placeholder="请输入内容" @change="handleEdit(scope.$index, scope.row)"></el-input> <span>{{scope.row.goodReturnServicePrice}}</span>
        </template>
      </el-table-column>
    </el-table-column>


    <el-table-column label="操作">
      <template slot-scope="scope">
        <!--<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
        <!--<el-button type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)"></el-button>-->
        <el-button size="small" disabled type="text" style="color: #04befe">点击编辑</el-button>
        <span v-if="isNotTemplateData">
        <span v-if="scope.row.id == null || scope.row.id == ''" style="margin-left: 10%;">
          <el-button type="primary" icon="el-icon-upload" circle @click="handleSave(scope.$index, scope.row)">
          </el-button>
        </span>
          </span>
      </template>
    </el-table-column>
  </el-table>
  <el-row style="margin-top: 2%;">
    <el-col :span="12">
      <el-button type="primary" icon="el-icon-plus" circle @click="addTableData"></el-button>
    </el-col>
    <el-col :span="12">
      <el-button type="primary" v-if="!isNotTemplateData" @click="saveAsAdminData" size="medium">保存</el-button>
      <el-button type="primary" @click="saveAsAdminTemplate" size="medium">保存模版</el-button>
      <el-button type="danger" @click="deleteAsAdminData" size="medium">删除数据</el-button>
    </el-col>
  </el-row>
  <el-pagination
      :page-sizes="[20, 50, 100, 200]"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="pagination.pageNum"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      @size-change="handlePageSizeChange"
      @current-change="handlePageNumChange"
      background
      style="float: right;margin-bottom: 10px">
  </el-pagination>

  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
      <el-form-item label="模版名称: ">
        <el-input v-model="dialogForm.salemanName" style="width: 50%;"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="saveSalemanMoneyData" size="mini" type="primary">确认添加定价</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {
  addSalemanWebMoneySetting,
  deleteSalemanWebMoneySetting,
  getSalemanWebMoneySetting, queryCustoMoneySettingModel,
  updateSalemanWebMoneySetting
} from "../api/b2cbusiness/b2c_customoneysetting";
import MixinCUD from "./MixinCUD";
import {
  addSalemanMoneySetBatchData, delSalemanMoneySetBatchData,
  querySalemanMoneySetModelTemplateData,
  querySalemanPriceSetModelTemplateData,
  saveSalemanMoneySetData,
  saveSalemanPriceSetTemplate
} from "../api/b2cbusiness/b2c_saleman";
import {isStrEmpty} from "../lib/utils";

export default {
  name: "SalemanMoneyData",
  mixins:[MixinCUD],
  props: ['selectMenuValue', 'salemanId'],
  data() {
    return {
      isNotTemplateData:true,
      tableData: [],
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{
      },
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  watch:{
    selectMenuValue(val) {
      this.selectMenuValue = val;
      console.log("---fdfdfdfdfddfd--", this.selectMenuValue);
      getSalemanWebMoneySetting({salemanId:this.salemanId, b2cTaskTypeId:this.selectMenuValue.id}, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    }
  },
  mounted() {
    this.getData();
  },
  methods:{
    saveAsAdminData(){
      addSalemanMoneySetBatchData(this.tableData, this.selectMenuValue.id, this.salemanId).then(res=>{
        if (res.success){
          this.tableData = res.data;
          this.isNotTemplateData = true;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    deleteAsAdminData(){
      this.$confirm("确定删除当前数据么?")
          .then(_ => {
            delSalemanMoneySetBatchData(this.tableData).then(res=>{
              if (res.success){
                this.$message.success("删除成功！")
                this.getData();
              }
            }).catch(err => {
              this.$message({message: err.message, type: 'error'});
            });
          }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    queryAdminSubModelData(priceMode){
      console.log("-----"+ priceMode)
      if (this.tableData.length > 0){
        this.$message.error("当前配置存在数据，不可获取模版数据！请先删除数据， 再获取");
      }else if (isStrEmpty(priceMode) || priceMode == null){
        this.$message.error("请选择模版名称");
      }else{
        querySalemanMoneySetModelTemplateData(priceMode, this.selectMenuValue.id).then(res=>{
          if (res.success){
              this.tableData = res.data;
              this.isNotTemplateData = false;
              this.$forceUpdate();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      }
    },
    saveAsAdminTemplate() {
      this.dialogFormVisible = true;
    },
    saveSalemanMoneyData(){
      saveSalemanMoneySetData(this.tableData, this.dialogForm.salemanName,2).then(res=>{
        if (res.success){
          this.dialogFormVisible = false
          this.$message.success("添加模版成功！")
          this.getData();
        }
      }).catch(err => {
        this.handleCloseDialog();
        this.$message({message: err.message, type: 'error'});
      });
    },
    getData(){
      getSalemanWebMoneySetting({salemanId:this.salemanId, b2cTaskTypeId:this.selectMenuValue.id},this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    },
    handleCurrentChange(row, event, column) {
      console.log(row, event, column, event.currentTarget)
    },
    handleEdit(index, row) {
      console.log(index, row);
      if (row.id != null && row.id != "") {
        updateSalemanWebMoneySetting(row).then(res => {
          console.log(res.data);
          if (res.success) {
            this.getData();
          }
        });
      }
    },
    handleDelete(index, row) {
      console.log(index, row);
      deleteSalemanWebMoneySetting(row.id).then(res => {
        console.log(res.data);
        if (res.success){
          this.getData();
        }
      });
    },
    handleSave(index, row){
      row.b2cTaskTypeId = this.selectMenuValue.id;
      row.salemanId = this.salemanId;
      console.log("_+_+_+_+_+_+", index, row);
      addSalemanWebMoneySetting(row).then(
          res => {
            console.log(res.data);
            if (res.success){
              this.getData();
            }
          }
      );
    },
    addTableData(){
      queryCustoMoneySettingModel({b2cTaskTypeId:this.selectMenuValue.id, salemanId:this.salemanId}).then(res=>{
        if (res.success){
          this.tableData.push(res.data);
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm();
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm();
    },
  }
}
</script>

<style scoped>
/deep/.el-table th > .cell {
  text-align: center;
}
/deep/.el-table .cell {
  text-align: center;
}
span{
  text-align: center;
}
.tb-edit .el-input {
  display: none
}
.tb-edit .current-row .el-input {
  display: block
}
.tb-edit .current-row .el-input+span {
  display: none
}

</style>
